import { FC } from "react"
import { TableHeadProps } from "./interface"
import { StyleTableHead,StyleTableRow,StyleTableHeader } from "./style"
const TableHead:FC<TableHeadProps> = ({
    columns
}) =>{
    return (
        <StyleTableHead>
            <StyleTableRow>
                {columns?.map((column: any) => (
                <StyleTableHeader key={column?.key}>{column?.title}</StyleTableHeader>
                ))}
            </StyleTableRow>
        </StyleTableHead>
    )
}

export default TableHead